import { render, staticRenderFns } from "./detailProductsCompound.vue?vue&type=template&id=e2c747fc"
import script from "./detailProductsCompound.vue?vue&type=script&lang=js"
export * from "./detailProductsCompound.vue?vue&type=script&lang=js"
import style0 from "./detailProductsCompound.vue?vue&type=style&index=0&id=e2c747fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports